import React, { useState } from 'react';
import * as Icons from 'react-feather';

const DossierDetail = ({ dossier, isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('chronologie');

    if (!isOpen || !dossier) return null;

    // Fonction pour rendre le contenu en fonction de l'onglet actif
    const renderTabContent = () => {
        switch (activeTab) {
            case 'chronologie':
                return (
                    <div className="relative">
                        {/* Chronologie améliorée avec une meilleure visibilité */}
                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-md">
                                    <Icons.CheckCircle size={20} />
                                </div>
                                <div className="w-1 h-full bg-green-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">28/04/2023 - 14:30</p>
                                <h4 className="font-semibold text-lg text-gray-800">Dossier créé</h4>
                                <p className="text-gray-700 mt-1">Le dossier a été créé par l'utilisateur</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-md">
                                    <Icons.File size={20} />
                                </div>
                                <div className="w-1 h-full bg-green-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">29/04/2023 - 09:15</p>
                                <h4 className="font-semibold text-lg text-gray-800">Documents téléchargés</h4>
                                <p className="text-gray-700 mt-1">L'utilisateur a téléchargé les documents requis</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-md">
                                    <Icons.CreditCard size={20} />
                                </div>
                                <div className="w-1 h-full bg-green-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">30/04/2023 - 11:22</p>
                                <h4 className="font-semibold text-lg text-gray-800">Paiement effectué</h4>
                                <p className="text-gray-700 mt-1">Paiement des frais de dossier validé</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-md">
                                    <Icons.Search size={20} />
                                </div>
                                <div className="w-1 h-full bg-green-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">02/05/2023 - 15:45</p>
                                <h4 className="font-semibold text-lg text-gray-800">Vérification des documents</h4>
                                <p className="text-gray-700 mt-1">Dossier examiné par l'équipe juridique</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-md">
                                    <Icons.Send size={20} />
                                </div>
                                <div className="w-1 h-full bg-green-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">05/05/2023 - 10:30</p>
                                <h4 className="font-semibold text-lg text-gray-800">Transmission à la juridiction</h4>
                                <p className="text-gray-700 mt-1">Dossier transmis au tribunal de commerce d'Abidjan</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-500 text-white shadow-md">
                                    <Icons.Clock size={20} />
                                </div>
                                <div className="w-1 h-full bg-blue-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-blue-50 p-3 rounded-lg shadow-sm border border-blue-100 flex-grow">
                                <p className="text-blue-500 text-sm font-medium">10/05/2023 - 14:20</p>
                                <h4 className="font-semibold text-lg text-blue-800">Traitement par l'administration</h4>
                                <p className="text-blue-700 mt-1">En cours d'examen par le greffier</p>
                            </div>
                        </div>

                        <div className="flex mb-8">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gray-300 text-white shadow-md">
                                    <Icons.FileText size={20} />
                                </div>
                                <div className="w-1 h-full bg-gray-200 mx-auto mt-2"></div>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg shadow-sm border border-gray-200 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">--</p>
                                <h4 className="font-semibold text-lg text-gray-800">Documents officiels générés</h4>
                                <p className="text-gray-700 mt-1">En attente de génération du RCCM et PV de dépôt</p>
                            </div>
                        </div>

                        <div className="flex">
                            <div className="flex-shrink-0 mr-4">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gray-300 text-white shadow-md">
                                    <Icons.MessageCircle size={20} />
                                </div>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg shadow-sm border border-gray-200 flex-grow">
                                <p className="text-gray-500 text-sm font-medium">--</p>
                                <h4 className="font-semibold text-lg text-gray-800">Communication au client</h4>
                                <p className="text-gray-700 mt-1">En attente d'envoi des documents au client</p>
                            </div>
                        </div>

                        {/* Boutons d'action */}
                        <div className="mt-8 flex space-x-4">
                            <button className="bg-black text-white px-4 py-2 rounded-md shadow-sm flex items-center hover:bg-gray-800 transition-colors">
                                <Icons.Send className="mr-2" size={18} />
                                Transmettre les documents
                            </button>
                            <button className="border border-gray-300 bg-white text-gray-800 px-4 py-2 rounded-md shadow-sm flex items-center hover:bg-gray-50 transition-colors">
                                <Icons.Check className="mr-2" size={18} />
                                Dossier complet
                            </button>
                        </div>
                    </div>
                );

            case 'documents':
                return (
                    <div>
                        {/* Documents uploadés par le client */}
                        <div className="space-y-4">
                            <div className="border rounded-md p-4 flex justify-between items-center bg-white shadow-sm hover:shadow-md transition-shadow">
                                <div>
                                    <h4 className="font-medium text-lg">Pièce d'identité</h4>
                                    <p className="text-gray-500">Ajouté le 28/04/2023</p>
                                </div>
                                <button className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors">
                                    <Icons.Download size={20} />
                                </button>
                            </div>

                            <div className="border rounded-md p-4 flex justify-between items-center bg-white shadow-sm hover:shadow-md transition-shadow">
                                <div>
                                    <h4 className="font-medium text-lg">Justificatif de domicile</h4>
                                    <p className="text-gray-500">Ajouté le 28/04/2023</p>
                                </div>
                                <button className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors">
                                    <Icons.Download size={20} />
                                </button>
                            </div>

                            <div className="border rounded-md p-4 flex justify-between items-center bg-white shadow-sm hover:shadow-md transition-shadow">
                                <div>
                                    <h4 className="font-medium text-lg">Formulaire de demande</h4>
                                    <p className="text-gray-500">Ajouté le 28/04/2023</p>
                                </div>
                                <button className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors">
                                    <Icons.Download size={20} />
                                </button>
                            </div>

                            <div className="border rounded-md p-4 flex justify-between items-center bg-white shadow-sm hover:shadow-md transition-shadow">
                                <div>
                                    <h4 className="font-medium text-lg">Attestation fiscale</h4>
                                    <p className="text-gray-500">Ajouté le 28/04/2023</p>
                                </div>
                                <button className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors">
                                    <Icons.Download size={20} />
                                </button>
                            </div>
                        </div>

                        {/* Bouton d'action */}
                        <div className="mt-8">
                            <button className="bg-black text-white px-4 py-2 rounded-md shadow-sm flex items-center hover:bg-gray-800 transition-colors">
                                <Icons.Send className="mr-2" size={18} />
                                Transmettre les documents
                            </button>
                        </div>
                    </div>
                );

            case 'documentsGeneres':
                return (
                    <div className="space-y-4">
                        {/* Documents générés en attente */}
                        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 flex justify-between items-center shadow-sm">
                            <div>
                                <h4 className="font-medium text-lg text-yellow-800">RCCM</h4>
                                <p className="text-yellow-600">En attente de génération</p>
                            </div>
                            <button className="text-gray-400 cursor-not-allowed p-2">
                                <Icons.Download size={20} />
                            </button>
                        </div>

                        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 flex justify-between items-center shadow-sm">
                            <div>
                                <h4 className="font-medium text-lg text-yellow-800">PV de Dépôt</h4>
                                <p className="text-yellow-600">En attente de génération</p>
                            </div>
                            <button className="text-gray-400 cursor-not-allowed p-2">
                                <Icons.Download size={20} />
                            </button>
                        </div>

                        {/* État du traitement */}
                        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 shadow-sm">
                            <h4 className="font-medium text-lg text-blue-800">État du traitement par la juridiction</h4>
                            <p className="text-blue-600 mb-3">Le dossier est en cours de traitement par le tribunal de commerce d'Abidjan.</p>

                            <div className="w-full bg-blue-200 rounded-full h-2.5">
                                <div className="bg-blue-600 h-2.5 rounded-full w-2/5"></div>
                            </div>
                            <p className="text-blue-600 mt-1 text-sm">Étape 2/5: Examen par le greffier</p>
                        </div>

                        {/* Bouton d'action */}
                        <div className="mt-4">
                            <button className="bg-black text-white px-4 py-2 rounded-md shadow-sm flex items-center hover:bg-gray-800 transition-colors">
                                <Icons.Send className="mr-2" size={18} />
                                Transmettre les documents
                            </button>
                        </div>
                    </div>
                );

            case 'notes':
                return (
                    <div className="space-y-4">
                        {/* Notes utilisateurs */}
                        <div className="border rounded-md p-4 bg-white shadow-sm">
                            <div className="flex justify-between">
                                <h4 className="font-medium text-gray-900">Sophie Dupré</h4>
                                <span className="text-gray-500 text-sm">29/04/2023 - 10:30</span>
                            </div>
                            <p className="mt-1 text-gray-700">Le client a été contacté pour compléter le dossier avec une attestation de résidence mise à jour.</p>
                        </div>

                        <div className="border rounded-md p-4 bg-white shadow-sm">
                            <div className="flex justify-between">
                                <h4 className="font-medium text-gray-900">Marc Koné</h4>
                                <span className="text-gray-500 text-sm">01/05/2023 - 14:15</span>
                            </div>
                            <p className="mt-1 text-gray-700">Dossier prêt à être transmis, en attente de validation finale par le responsable juridique.</p>
                        </div>

                        <div className="border rounded-md p-4 bg-white shadow-sm">
                            <div className="flex justify-between">
                                <h4 className="font-medium text-gray-900">Aminata Diallo</h4>
                                <span className="text-gray-500 text-sm">05/05/2023 - 11:30</span>
                            </div>
                            <p className="mt-1 text-gray-700">Dossier transmis à la juridiction d'Abidjan. Délai estimé de traitement: 5-7 jours ouvrables.</p>
                        </div>

                        {/* Bouton d'action */}
                        <div className="mt-4">
                            <button className="bg-black text-white px-4 py-2 rounded-md shadow-sm flex items-center hover:bg-gray-800 transition-colors">
                                <Icons.Send className="mr-2" size={18} />
                                Transmettre les documents
                            </button>
                        </div>
                    </div>
                );

            default:
                return <div>Contenu non disponible</div>;
        }
    };

    return (
        <div className="fixed inset-0 bg-transparent z-50 flex justify-end backdrop-filter backdrop-blur-sm">
            <div
                className={`bg-white w-full max-w-lg h-full overflow-y-auto transform transition-transform duration-300 shadow-xl ${isOpen ? 'translate-x-0' : 'translate-x-full'
                    }`}
            >
                {/* Entête avec bouton de fermeture */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex justify-between items-center mb-1">
                        <h2 className="text-xl font-bold text-gray-900">Détails du dossier {dossier.id}</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors"
                        >
                            <Icons.X size={24} />
                        </button>
                    </div>

                    {/* Client et statut */}
                    <div className="flex justify-between items-center mt-4 mb-6">
                        <h3 className="text-xl text-gray-800">{dossier.nomClient}</h3>
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${dossier.statut === 'En cours' ? 'bg-blue-100 text-blue-700' :
                            dossier.statut === 'Complété' ? 'bg-green-100 text-green-700' :
                                'bg-yellow-100 text-yellow-700'
                            }`}>
                            {dossier.statut}
                        </span>
                    </div>

                    {/* Informations de base */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div>
                            <p className="text-gray-500">Type de dossier</p>
                            <p className="font-medium text-gray-800">{dossier.type}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Date de création</p>
                            <p className="font-medium text-gray-800">{dossier.dateCreation}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Juridiction</p>
                            <p className="font-medium text-gray-800">{dossier.juridiction}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Étape actuelle</p>
                            <p className="font-medium text-gray-800">{dossier.etape}</p>
                        </div>
                    </div>
                </div>

                {/* Onglets de navigation */}
                <div className="border-b border-gray-200 bg-gray-50">
                    <div className="flex overflow-x-auto px-6">
                        <button
                            className={`mr-6 py-4 border-b-2 font-medium whitespace-nowrap ${activeTab === 'chronologie' ? 'border-black text-black' : 'border-transparent text-gray-500'
                                }`}
                            onClick={() => setActiveTab('chronologie')}
                        >
                            Chronologie
                        </button>
                        <button
                            className={`mr-6 py-4 border-b-2 font-medium whitespace-nowrap ${activeTab === 'documents' ? 'border-black text-black' : 'border-transparent text-gray-500'
                                }`}
                            onClick={() => setActiveTab('documents')}
                        >
                            Documents
                        </button>
                        <button
                            className={`mr-6 py-4 border-b-2 font-medium whitespace-nowrap ${activeTab === 'documentsGeneres' ? 'border-black text-black' : 'border-transparent text-gray-500'
                                }`}
                            onClick={() => setActiveTab('documentsGeneres')}
                        >
                            Documents Générés
                        </button>
                        <button
                            className={`py-4 border-b-2 font-medium whitespace-nowrap ${activeTab === 'notes' ? 'border-black text-black' : 'border-transparent text-gray-500'
                                }`}
                            onClick={() => setActiveTab('notes')}
                        >
                            Notes
                        </button>
                    </div>
                </div>

                {/* Contenu de l'onglet actif */}
                <div className="p-6 bg-gray-50 min-h-screen">
                    {renderTabContent()}
                </div>
            </div>
        </div>
    );
};

export default DossierDetail;